export default {
  manage_driverStatus: "Driver Status",
  manage_driverStatusTable_driverStatusName: "Name",
  manage_driverStatusTable_accumulateTime: "Accumulation Time",
  manageDriverStatus_clockIn: "Clock in",
  manageDriverStatus_clockOut: "Clock out",
  manageDriverStatus_mealBreakBegin: "Meal Break Begin",
  manageDriverStatus_mealBreakEnd: "Meal Break End",
  manage_driverStatus_search_by_name: "Search by Name",
};
